import {Button, Col, Flex, Form, Input, Row, Spin} from 'antd'
import {ReactComponent as LogoSVG} from '../gfx/logo.svg'
import {Link, useNavigate} from 'react-router-dom'
import FloatLabel from '../components/inputs/FloatLabel'
import {ReactComponent} from '../app'

export class LoginPage extends ReactComponent {
  state = {
    loading: false,
    email: "",
    password: "",

  }

  componentDidMount() {

  }


  async handleLogin () {
    await this.updateState({loading: true})

    await this.props.$auth.authenticate(this.state.email, this.state.password)

    void this.updateState({loading: false})
  }

  render () {
    return (
      <Flex
        className="login-page"
        vertical={true}
        justify="center"
        align="space-between"
      >

        <LogoSVG className="logo"/>

        <Row justify="center">
          <Col span={16}>
            <Form
              layout="vertical"
              onFinish={() => {void this.handleLogin()}}
              autoComplete="off"
            >

              <Form.Item>
                <FloatLabel label="E-mail" value={this.state.email}>
                  <Input
                    name="test"
                    variant="underlined"
                    value={this.state.email} onChange={(e) => this.updateState({email: e.target.value})}/>
                </FloatLabel>
              </Form.Item>

              <Form.Item>
                <FloatLabel label="Heslo" value={this.state.password}>
                  <Input.Password
                    name="password"
                    variant="underlined"
                    value={this.state.password} onChange={(e) => this.updateState({password: e.target.value})}
                  />
                </FloatLabel>
              </Form.Item>

              <Form.Item label={null}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  icon={<Spin spinning={this.state.loading}/>}
                >Přihlásit</Button>

                <p className="mt-2 mb-0 ta-center">Nemáte účet? <Button type="link" onClick={() => {
                  this.props.navigate('/registration')
                }}>Registrujte se</Button></p>
                <p className="mt-0 ta-center">Zapoměli jste heslo? <Button type="link" onClick={() => {
                  this.props.navigate('/password-recovery')
                }}>Obnovit heslo</Button></p>
              </Form.Item>

            </Form>
          </Col>
        </Row>

        <Row justify="center" style={{flexGrow: '1'}}>
          <Flex
            align="flex-end"
            className="mb-2"
          >
            <p><Link to="/terms"><strong>Obchodní podmínky</strong></Link> a souhlas s <Link to="/privacy-policy">GDPR</Link></p>
          </Flex>
        </Row>

      </Flex>
    )
  }
}

export default function LoginPageHOC ({$auth}) {
  const navigate = useNavigate()

  return (<LoginPage $auth={$auth} navigate={navigate} />)

}